import React from "react";
import { NO_SPEECH_RECOGNITION_MESSAGE } from "./constants";

/**
 * Renders the full AI Speech Recognition box content when no speech data is available.
 * Use this to replace the entire content of the AI Speech Recognition section
 * when Kaldi cannot process the recording (unclear audio or insufficient speech).
 */
export default function AiSpeechRecognitionEmptyState() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "80px",
        padding: "24px 16px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          color: "#555",
          fontSize: "14px",
          lineHeight: "1.5",
          fontWeight: "500",
          maxWidth: "400px",
        }}
      >
        {NO_SPEECH_RECOGNITION_MESSAGE}
      </div>
      <div style={{ marginTop: "12px", fontSize: "24px", opacity: 0.7 }}>
        🎙️❓
      </div>
    </div>
  );
}
